export default __webpack_public_path__ + "static/media/Video_share_icon.a99d0115.svg";